<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- name -->
      <div class="columns">
        <div class="column has-text-centered"><label>Ime sektora:</label></div>
        <div class="column is-four-fifths">
          <input
            class="input is-small has-text-centered has-background-info-light"
            type="text"
            v-model="selectedDepartment.name"
          />
        </div>
      </div>
      <!-- radno vrijeme -->
      <div class="columns">
        <div class="column has-text-centered">
          <label>Radno vrijeme:</label>
        </div>
        <div class="column has-text-centered is-four-fifths">
          <vue-select
            class="has-background-info-light"
            type="text"
            label="name"
            :clearable="false"
            :options="shifts"
            v-model="selectedShift"
          />
        </div>
      </div>
      <!-- radne subote -->
      <div class="columns">
        <div class="column has-text-centered">
          <label>Radne subote:</label>
        </div>
        <div class="column has-text-centered is-four-fifths">
          <vue-select
            class="has-background-info-light"
            type="text"
            label="name"
            :clearable="false"
            :options="saturdayShifts"
            v-model="selectedSaturdayShift"
          />
        </div>
      </div>
      <!-- Buttons -->
      <div class="columns">
        <div v-show="isSaveAndProceedButtonVisible" class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndProceedButtonClicked"
          >
            SAČUVAJ I NASTAVI
          </button>
        </div>
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndCloseButtonClicked"
          >
            SAČUVAJ I ZATVORI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditDepartment",

  props: {
    title: String,
    selectedDepartment: Object,
    shifts: Array,
    saturdayShifts: Array,
    isSaveAndProceedButtonVisible: Boolean,
  },

  data() {
    return {
      selectedShift: null,
      selectedSaturdayShift: null,
    };
  },

  mounted() {
    this.selectedShift = this.shifts.find((sh) => {
      return sh.id == this.selectedDepartment.shiftId;
    });
    console.log("jedan");
    console.log(this.saturdayShifts);
    this.selectedSaturdayShift = this.saturdayShifts.find((sh) => {
      return sh.id == this.selectedDepartment.saturdayShiftId;
    });
    console.log(this.shifts);

    console.log(this.selectedShift);
    console.log(this.selectedShift);
  },

  methods: {
    saveAndProceedButtonClicked() {
      // this.selectedDepartment.shiftId = this.selectedShift.id;
      // this.$emit("saveAndProceedButtonClicked", this.selectedDepartment);
    },
    saveAndCloseButtonClicked() {
      this.selectedDepartment.shiftId = this.selectedShift.id;
      this.selectedDepartment.saturdayShiftId = this.selectedSaturdayShift.id;
      this.$emit("saveAndCloseButtonClicked", this.selectedDepartment);
    },
  },
};
</script>
